import { render, staticRenderFns } from "./noDataPermission.vue?vue&type=template&id=78fd1e95&scoped=true"
var script = {}
import style0 from "./noDataPermission.vue?vue&type=style&index=0&id=78fd1e95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd1e95",
  null
  
)

export default component.exports